import { FieldError } from 'react-hook-form';

export const formatErrorsToRedux = (errors: Record<string, FieldError>) => {
  return Object.entries(errors).reduce((acc: Record<string, string>, [key, value]) => {
    return {
      ...acc,
      [key]: value.message || '',
    };
  }, {});
};
